import update from 'react/lib/update';
import * as actionConsts from './actions';


export const initState = {
  apvs: [],
  init: [],
}

export default (state = initState, action) => {
  switch (action.type) {
    case actionConsts.SET_APVS:
      return update(state, {
        apvs: {
          $set: action.apvs
        },
        init: {
          $set: action.init
        }
      })
    case actionConsts.SET_APV:
      return update(state, {
        apvs: {
          [action.index]: {
            $set: action.obj
          }
        }
      })
    case actionConsts.UPDATE_APV:
      return update(state, {
        apvs: {
          [action.index]: {
            [action.key]: {
              $set: action.value
            },
            changed: {
              $set: true
            }
          }
        }
      })
    case actionConsts.UPDATE_APV_PDF:
      return update(state, {
        apvs: {
          [action.index]: {
            document: {
              $set: action.document
            },
            changed: {
              $set: true
            }
          }
        }
      })
    case actionConsts.SAVE_APV_SUCCESS:
      return update(state, {
        apvs: {
          [action.index]: {
            changed: {
              $set: false
            },
            id: {
              $set: action.id
            },
            document: {
              $set: action.document
            }
          }
        },
        init: {
          [action.index]: {
            changed: {
              $set: false
            },
            id: {
              $set: action.id
            },
            document: {
              $set: action.document
            },
            name: {
              $set: action.name
            }
          }
        }
      })
    case actionConsts.ADD_ROW:
      return update(state, {
        apvs: {
          $unshift: [action.row]
        },
        init: {
          $unshift: [action.row]
        }
      })
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/App/APV/reducer.js